import { render, staticRenderFns } from "./my-order.vue?vue&type=template&id=0ac43e28&scoped=true&"
import script from "./my-order.vue?vue&type=script&lang=js&"
export * from "./my-order.vue?vue&type=script&lang=js&"
import style0 from "./my-order.vue?vue&type=style&index=0&id=0ac43e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac43e28",
  null
  
)

component.options.__file = "my-order.vue"
export default component.exports